import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';

const codeBlockStyle = {
  background: 'var(--navy-900)',
  borderRadius: 'var(--radius)',
  padding: '18px 20px',
  margin: '18px 0',
  fontSize: '13.5px',
};

const components = {
  code({ node, inline, className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || '');
    return !inline && match ? (
      <SyntaxHighlighter style={vscDarkPlus} language={match[1]} PreTag="div" customStyle={codeBlockStyle} {...props}>
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    );
  },
};

// Conteúdo em Markdown com a tipografia do StudySpace e código no tema azul-marinho.
export function Markdown({ children, className = '' }) {
  return (
    <div className={`ss-markdown ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{children}</ReactMarkdown>
    </div>
  );
}
